import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FeatureDiscoveryTour } from "./types";
import {
  TourBadge,
  TourButton,
  TourCloseButton,
  TourContainer,
  TourContent,
  TourCopy,
  TourDialog,
  TourFooter,
  TourHeader,
  TourImage,
  TourProgress,
  TourTextColumn,
  TourTitle,
  TourTitleGroup,
} from "./FeatureDiscoveryTourModal.styles";

interface FeatureDiscoveryTourModalProps {
  tour: FeatureDiscoveryTour;
  onClose: (completed: boolean) => void;
}

export const FeatureDiscoveryTourModal = ({
  tour,
  onClose,
}: FeatureDiscoveryTourModalProps): React.ReactElement => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const activeSlide = tour.slides[activeSlideIndex];
  const isFirstSlide = activeSlideIndex === 0;
  const isLastSlide = activeSlideIndex === tour.slides.length - 1;

  return (
    <TourDialog open onClose={() => onClose(false)} maxWidth={false}>
      <TourContainer>
        <TourHeader>
          <TourTitleGroup>
            <TourTitle>{tour.title}</TourTitle>
            <TourBadge>{tour.badgeLabel}</TourBadge>
          </TourTitleGroup>
          <TourCloseButton
            aria-label="Close feature tour"
            onClick={() => onClose(false)}
            size="large"
          >
            <FontAwesomeIcon icon={faXmark} />
          </TourCloseButton>
        </TourHeader>
        <TourContent>
          <TourTextColumn>
            <TourCopy>{activeSlide.body}</TourCopy>
            <TourFooter>
              {!isFirstSlide && (
                <TourButton
                  $variant="secondary"
                  type="button"
                  onClick={() => setActiveSlideIndex(activeSlideIndex - 1)}
                >
                  Prev
                </TourButton>
              )}
              <TourProgress>
                {activeSlideIndex + 1} of {tour.slides.length}
              </TourProgress>
              <TourButton
                $variant="primary"
                type="button"
                onClick={() => {
                  if (isLastSlide) {
                    onClose(true);
                    return;
                  }
                  setActiveSlideIndex(activeSlideIndex + 1);
                }}
              >
                {isLastSlide ? "Finish" : "Next"}
              </TourButton>
            </TourFooter>
          </TourTextColumn>
          <TourImage src={activeSlide.image} alt={activeSlide.imageAlt} />
        </TourContent>
      </TourContainer>
    </TourDialog>
  );
};
